module.exports = __webpack_public_path__ + "static/media/profileCircle.f233afd3.svg";